module.exports = __webpack_public_path__ + "static/media/texture (13).2028d435.jpg";